export default {"src":"/_next/static/media/locationAdmin.76faaa67.svg","height":82,"width":81};